import React from 'react';
import styles from './DemoPreviewOverlay.module.css';

interface DemoPreviewOverlayProps {
  onClose: () => void;
}

/**
 * 키오스크 미리보기 오버레이
 * - 실제 매장(storeId) 연결 없이 kiosk.만석.com에 접속했을 때 표시
 * - 반투명 검은 배경 + 중앙 안내 카드 + 닫기 버튼
 * - 닫기 시 내부 키오스크 UI(데모 모드)를 자유롭게 탐색 가능
 */
export function DemoPreviewOverlay({ onClose }: DemoPreviewOverlayProps) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.card}>
        <div className={styles.badge}>미리보기</div>
        <h1 className={styles.title}>키오스크 화면 미리보기</h1>
        <p className={styles.description}>
          실제 매장에 설치되는 <strong>만석 키오스크 화면</strong>을 직접 체험해볼 수 있습니다.
        </p>
        <div className={styles.features}>
          <div className={styles.featureItem}>
            <span className={styles.bullet}>·</span>
            <span>매장 이름 확인 → 대기 등록 시작</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet}>·</span>
            <span>언어 선택 (한국어 / English / 日本語 / 中文)</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet}>·</span>
            <span>전화번호 입력 + 인원수 선택</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet}>·</span>
            <span>대기 번호 발급 + 알림톡 발송 시뮬레이션</span>
          </div>
        </div>
        <div className={styles.notice}>
          이 화면은 <strong>데모 환경</strong>이며, 입력한 정보는 저장되지 않고
          실제 알림톡도 발송되지 않습니다.
        </div>
        <button type="button" className={styles.closeButton} onClick={onClose}>
          둘러보기 시작
        </button>
      </div>
    </div>
  );
}
